import React,{useState} from 'react'
import { FaArrowRight } from 'react-icons/fa'
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux/es/hooks/useSelector';
import { slideTopDelay } from '../animations';
import axios from 'axios';
import { baseURL } from '../Api';
import MainLoader from './MainLoader';

const Card = ({ category }) => {
  const user = useSelector(state => state.user)
  const [Loading, setLoading] = useState(false)

 
  const handleBuy = async () => {
    try {
      setLoading(true)
      const res = await axios.post(
        `${baseURL}pay/buy/${category.id}/`,
        {},
        {
          headers: { Authorization: `Token ${user.token}` },
        }
      );
      if (res.status === 200) {
        alert("Successfully bought");
         window.location.href = '/bank/extraction'
      } else {
        alert("Not Enough Balance");
      }
    } catch (error) {
      console.log("An error occurred", error);
      alert("Not Enough Balance");
    } finally{
      setInterval(() => {
        setLoading(false);
        window.location.reload()
      }, 2000);
    }
  };
  
  
  return (
    <div>
         <motion.div {...slideTopDelay} className='md:w-[1100px] md:h-[170px] h-[500px] w-[370px]  bg-[#212123] mt-20 rounded-[20px] flex flex-row  md:gap-[100px]'>
                <p className='text-2xl font-bold text-green-600 flex items-center md:pl-10 pl-5'>${category?.price}</p>
            
                <div className='flex md:flex-row justify-center items-center md:gap-10 md:pl-[100px] pl-[40px] gap-[10px] '>
                <p className='md:text-[20px] md:w-[300px] w-[100px] text-15  text-white'>{category.Info}</p>
                
                <div className='flex flex-col md:flex-row gap-5 ml-10'>
                <p className='text-2xl font-bold  text-white'>$  {category?.Balance}</p>
                <div className='flex md:flex-row md:items-center md:justify-center' onClick={handleBuy}>
                    <div className='bg-white flex items-center justify-center  w-[90px] h-[60px] rounded-[30px] md:ml-[120px] hover:text-white hover:bg-red-500 font-bold hover:cursor-pointer '>
                       {Loading ? (
                        <MainLoader />
                       ) : (
                        <p>Buy</p>
                       )}
                    </div>

                    <FaArrowRight size={30} className='text-white ml-5 hidden md:visible' />
                </div>
                </div>
                </div>
          </motion.div>

  </div>
  )
}

export default Card
